import React, { Component } from "react";

export class LeadsCenteredModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.LeadsCenteredModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, onClose, modalSize, modaltype, hidecancelbtn } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs
        id={id}
        title={title}
        onClose={onClose}
        modalSize={modalSize}
        hidecancelbtn={hidecancelbtn}
      >
        <AppFormData
          {...attrs}
          onClose={onClose}
          modaltype={modaltype}
          hidecancelbtn={hidecancelbtn}
        ></AppFormData>
      </AppModalBs>
    );
  }
}

export default LeadsCenteredModal;
